import { Dispatch } from "redux";
import { setLoading } from "./global";
import { showMessage } from "utilities/helper";
import RaffleEventService from "service/RaffleEvent";

export const getAllRaffleEvents =
  (page: number = 1, search: string = "", limit: number = 10) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_RAFFLE_EVENT_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_RAFFLE_EVENT",
      searchValue: search,
    });

    try {
      const data = await RaffleEventService.getAllRaffleEvents(page, search, limit);

      dispatch(setLoading(false));
      dispatch({ type: "SET_RAFFLE_EVENT", value: data.raffle_events });
      dispatch({
        type: "SET_RAFFLE_EVENT_PAGE",
        totalPage: !!data.raffle_events.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.raffle_events.length ? data.total_data : 1,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };